module.exports = __webpack_public_path__ + "img/zk-icon-cash.e1916155.svg";